import { useEffect, useState } from "react";

import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import api from "../../../services/api";

import './styles.css';

export const PCPRestricao = () => {
    const [data, setData] = useState([]);
    const [artigo, setArtigo] = useState("");
    const [loading, setLoading] = useState(false);

    const formatNumber = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData[props.field]);
    }

    useEffect(() => {
        setLoading(true);
        api.get('pcp-restricoes').then(response => {
            setData(response.data);
            setLoading(false);
        }).catch(error => {
            setLoading(false);
            setData([]);
        });
    }, []);
    
    if(loading)
        return <Loading />

    return (
        <div>
            <Menu />
            
            <Card
                className="p-m-1"
                title="PCP Restrições"
            >
                <div className="p-d-flex p-flex-row p-justify-end">
                    <InputText 
                        className="p-m-1"
                        onChange={e => setArtigo(e.target.value)}
                        value={artigo}
                    />    
                </div>

                <DataTable
                    emptyMessage=""
                    globalFilter={artigo}
                    globalFilterFields={["cod_artigo"]}
                    size="small"
                    value={data}
                >
                    <Column headerClassName="stickyToTopTableHeaders" filterMatchMode="startsWith" header='Artigo' field="cod_artigo" sortable />
                    <Column headerClassName="stickyToTopTableHeaders" header='1º' field="class1" sortable body={formatNumber} />
                    <Column headerClassName="stickyToTopTableHeaders" header='2º' field="class2" sortable body={formatNumber} />
                    <Column headerClassName="stickyToTopTableHeaders" header='3º' field="class3" sortable body={formatNumber} />
                    <Column headerClassName="stickyToTopTableHeaders" header='4º' field="class4" sortable body={formatNumber} />
                    <Column headerClassName="stickyToTopTableHeaders" header='Total' field="total" sortable body={formatNumber} />
                    <Column headerClassName="stickyToTopTableHeaders" header='Retrabalho' field="retrabalhototal" sortable body={formatNumber} />
                    <Column headerClassName="stickyToTopTableHeaders" header='Reprocesso' field="reprocessototal" sortable body={formatNumber} />
                    <Column headerClassName="stickyToTopTableHeaders" header='Restrição' field="restricaototal" sortable body={formatNumber} />
                    <Column headerClassName="stickyToTopTableHeaders" header='L Fora Padrão' field="lforapadraototal" sortable body={formatNumber} />
                </DataTable>
            </Card>
        </div>
    )
}